import { Component, ViewChild, ViewEncapsulation, OnInit } from '@angular/core';
import { transition, animate, style, trigger } from '@angular/animations';
import { AppService } from '../../../../app.service';
import { FrontEndComponetService } from '../front-end-componet.service';
import { ObsHistoryMenuItemComponentType } from './fecr-observation-history.model';
import { ActivatedRoute } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';


@Component({
  selector: 'app-fecr-observation-history',
  templateUrl: './fecr-observation-history.component.html',
  styleUrls: ['./fecr-observation-history.component.scss'],
  animations: [
    trigger(
      'enterAnimation', [
      transition(':enter', [
        style({ height: '1px', opacity: 0 }),
        animate('250ms', style({ height: '324px', opacity: 1 }))
      ]),
      transition(':leave', [
        style({ height: '324px', opacity: 1 }),
        animate('250ms', style({ height: '1px', opacity: 0 }))
      ])
    ]
    )],
  encapsulation: ViewEncapsulation.None
})
export class FecrObservationHistoryComponent implements OnInit {

  @ViewChild('mySelect') mySelect;

  constructor(private route: ActivatedRoute, private _sanitizer: DomSanitizer,
    private _appService: AppService, private _fecrService: FrontEndComponetService,) { }

  arrInspectionTypes: any[];
  ObservationID: number;
  implementId: number;
  ObsHistoryMenuList:ObsHistoryMenuItemComponentType []
  SelectedObsPoint:number

  ngOnInit() {

    this._appService.setPageTitle("Component Rebuild Observation Point History");
    //this._appService.setPageSubTitle("");
    this.route.params.subscribe(params => {
      this.implementId = +params['implementId'];
      this.ObservationID = +params['obsId'];

      if (this.ObservationID) {
        this.initialise();
      }
    });

  }

  initialise() {
    console.log("ObservationID", this.ObservationID)
    console.log("implementId", this.implementId)

    this._fecrService.GETObservationPointDetailsUsingType(this.implementId, this.ObservationID).subscribe(r => {
      console.log("GETObservationPointDetailsUsingType", r)
      if (r) {
        this.arrInspectionTypes = r.ObsDetails
        console.log("this.arrInspectionTypes", this.arrInspectionTypes)
      }
    })

    //load menu item
    this._fecrService.GETObsHistoryMenu(this.implementId, this.ObservationID).subscribe(r => {
      
      if (r) {
        this.ObsHistoryMenuList = r
      }
      console.log("this.ObsHistoryMenuList", this.ObsHistoryMenuList)
    })
  }

  getImage(image: string) {
    return this._sanitizer.bypassSecurityTrustResourceUrl('data:image/*;base64,' + image);
  }

  openMenu() {
    this.mySelect.open();
  }

  ObservationPointMenuItemSelect(val){
  console.log("values selected", val)
    this._fecrService.GETObservationPointDetailsUsingType(this.implementId, val).subscribe(r => {
      console.log("GETObservationPointDetailsUsingType__", r)
      if (r) {
        this.arrInspectionTypes = r.ObsDetails
        console.log("this.arrInspectionTypes____", this.arrInspectionTypes)
      }
    })
    
  }


}
